export const getMonthOffset = (endDate: string | Date, startDate: string | Date = new Date()): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  return (end.getFullYear() - start.getFullYear()) * 12 + end.getMonth() - start.getMonth();
};
